import dataType from '../dataType';

const accuracyValidation = {
    type: dataType.boolean
};

export default accuracyValidation;
